import { PushDataLayerFn } from '../../../types/pushDataLayer';

export const firePromotionsRender = (
  pushDataLayer: PushDataLayerFn,
  payload: {
    productId: string;
    market: string;
    hasProviderReward: boolean;
    hasItem3: boolean;
    totalMaxValue: number;
  },
) => {
  pushDataLayer({
    event: 'pdp.promotions.render',
    ...payload,
  });
};

export const firePromotionsExpand = (pushDataLayer: PushDataLayerFn) => {
  pushDataLayer({
    event: 'pdp.promotions.expand',
  });
};

export const fireRewardTileClick = (
  pushDataLayer: PushDataLayerFn,
  payload: {
    source: 'singsaver' | 'provider';
    rewardId: string;
    name: string;
    value: number;
  },
) => {
  pushDataLayer({
    event: 'pdp.promotions.rewardTile.click',
    ...payload,
  });
};
